import { render, staticRenderFns } from "./ModalListaPortaria.vue?vue&type=template&id=49c211ce"
import script from "./ModalListaPortaria.vue?vue&type=script&lang=js"
export * from "./ModalListaPortaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports